import React from 'react'
import {Button, Card, CardBody, Col, Form, FormGroup, Input, InputGroup, Modal, Row} from "reactstrap";
import dateHelpers from "../../../helpers/DateHelper";
import Select from "react-select";
import ClassApiService from "../../../api/classes-api-service";
import CardHeader from "reactstrap/es/CardHeader";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../../translations/resource_translations";
import localeHelpers from "../../../helpers/LocaleHelper";
import {common_strings} from "../../../translations/common_translations";
import EditTeacherView from "../Teacher/EditTeacherView";
import ResourceApiService from "../../../api/resource-api-service";
import EditRoomView from "../EditRoomView";
import {RotateCircleLoading} from "react-loadingg";
import resourceHelper from "../../../helpers/ResourceHelper";
import placeholderHelper from "../../../helpers/PlaceholderHelper";
import TimePicker from 'react-time-picker';
import '../../../assets/css/TimePicker.css';
import 'react-clock/dist/Clock.css';
import businessHelper from "../../../helpers/BusinessHelper";
import storage from "../../../Firebase";
import firebaseHelper from "../../../helpers/FirebaseHelper";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);

const propTypes = {};

class EditClassView extends React.Component {
    handleChange = this.handleChange.bind(this);
    addRoom = this.addRoom.bind(this);
    addTeacher = this.addTeacher.bind(this);
    closeEditTeacherView = this.closeEditTeacherView.bind(this);
    closeEditRoomView = this.closeEditRoomView.bind(this);
    processStatTimeUpdate = this.processStatTimeUpdate.bind(this);
    processEndTimeUpdate = this.processEndTimeUpdate.bind(this);
    chooseImage = this.chooseImage.bind(this);
    deletePhoto = this.deletePhoto.bind(this);

    constructor(props) {
        super(props);

        this.fileRef = React.createRef();
        this.state = {
            yclass: props.yclass,
            date: props.date,
            teachers: props.teachers,
            rooms: props.rooms,
            classType: props.classType,
            inputsUpdated: true,
            showTeacherModal: false,
            showSaveClassWarning: false,
            timeLocale: businessHelper.business().time_fmt === "eu" ? "en-UK" : "en-US",
            showRoomModal: false,
            validation: {
                date: true,
                start: true,
                end: true,
            }
        };
    }

    handleChange(event) {
        if (!event.target) {
            this.processTimeUpdate()
        }

        let newValue = event.target.value;
        let targetId = event.target.id;
        let checkBoxValue = event.target.checked;

        switch (targetId) {
            case "input-start":
                this.setState(prevState => ({
                    yclass: {
                        ...prevState.yclass,
                        start: newValue
                    }
                }));
                break;
            case "input-end":
                this.setState(prevState => ({
                    yclass: {
                        ...prevState.yclass,
                        end: newValue
                    }
                }));
                break;
            case "input-date":
                this.setState(prevState => ({
                    yclass: {
                        ...prevState.yclass,
                        date: newValue
                    }
                }));
                break;
            case "input-date-end":
                this.setState(prevState => ({
                    yclass: {
                        ...prevState.yclass,
                        date_end: newValue
                    }
                }));
                break;
            case "input-free-cb":
                this.setState(prevState => ({
                    yclass: {
                        ...prevState.yclass,
                        is_free: checkBoxValue
                    }
                }));
                break;
            case "input-capacity":
                this.setState(prevState => ({
                    yclass: {
                        ...prevState.yclass,
                        capacity: newValue
                    }
                }));
                break;
            case "input-online-cb":
                this.setState(prevState => ({
                    yclass: {
                        ...prevState.yclass,
                        is_online: checkBoxValue
                    }
                }));
                break;
            case "input-link":

                this.setState(prevState => ({
                    yclass: {
                        ...prevState.yclass,
                        link: newValue
                    }
                }));

                break;
            case "input-note":

                this.setState(prevState => ({
                    yclass: {
                        ...prevState.yclass,
                        note: newValue
                    }
                }));

                break;
            case "input-details":

                this.setState(prevState => ({
                    yclass: {
                        ...prevState.yclass,
                        details: newValue
                    }
                }));

                break;
            default:
                return
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.yclass !== this.props.yclass || nextProps.yclassType !== this.props.yclassType) {
            this.setState({
                yclass: nextProps.yclass,
                yclassType: nextProps.yclassType,
            })
        }
        if (nextState.yclass !== this.state.yclass
            || nextState.yclassType !== this.state.yclassType
            || nextState.selectedTicketType !== this.state.selectedTicketType
            || nextState.inputsUpdated !== this.state.inputsUpdated
            || nextState.validation.start !== this.state.validation.start
            || nextState.validation.end !== this.state.validation.end) {
            this.setState({
                yclass: nextState.yclass,
                yclassType: nextState.yclassType,
                selectedTicketType: nextState.selectedTicketType,
                inputsUpdated: nextState.inputsUpdated,
                validation: nextState.validation,
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.yclass !== this.state.yclass) {
            this.handleValidation();
        }
    }

    getClassTypes() {
        this.setState({isLoading: true});

        ResourceApiService.classTypes()
            .then(res => {
                this.setState({
                    classTypes: res,
                    isLoading: false
                });

            })
            .catch((e) => {
                this.props.handleError(e)
            });
    }

    componentDidMount() {
        if (!this.props.classTypes) {
            this.getClassTypes()
        }
        if (!this.props.teachers) this.getTeachersAndRooms()
    }

    getTeachersAndRooms() {
        this.setState({isLoading: true});

        ResourceApiService.teachersAndRooms()
            .then(res => {
                this.setState({
                    isLoading: false,
                    teachers: res[0] || [],
                    rooms: res[1] || [],
                });

            })
            .catch((e) => {
                this.props.handleError(e)
            });
    }

    updateYclass(e) {
        if (e) {
            e.preventDefault();
        }

        if (this.validationCleared()) {
            this.setState({isLoading: true});

            const y = this.state.yclass;
            y.teacher_ids = (this.state.yclass.teachers || []).map(t => t.id);
            y.room_id = this.getRoom() ? this.getRoom().value : null;

            if (this.state.yclass.id) {
                ClassApiService.update(this.state.yclass.id, y)
                    .then(res => {
                        this.setState({
                            isLoading: false
                        });

                        this.props.closeEditClassView()
                    })
                    .catch((e) => {
                        this.props.handleError(e)
                    });
            } else {
                ClassApiService.post(y)
                    .then(res => {
                        this.setState({
                            isLoading: false
                        });

                        this.props.closeEditClassView()
                    })
                    .catch((e) => {
                        this.props.handleError(e)
                    });
            }
        }
    }

    onChangeFile(event) {
        event.stopPropagation();
        event.preventDefault();
        const file = event.target.files[0];
        console.log(file);
        this.setState({file}); /// if you want to upload latter
        this.uploadWorkshopPhoto(file);
    }

    uploadWorkshopPhoto(file) {
        if (!file) return;

        this.setState({
            isLoading: true,
        });
        const businessId = businessHelper.business().id;
        const uploadTask = storage.ref(`workshops/${businessId}/workshop_${this.state.yclass.id || Math.random()}`).put(file);

        uploadTask.on(
            "state_changed",
            snapshot => {
                // progress function ...
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
                this.setState({progress});
            },
            error => {
                this.setState({
                    isLoading: false,
                });
                this.handleNetworkError(error);
                console.log(error);
            },
            () => {
                storage
                    .ref(`workshops/${businessId}`)
                    .child(`workshop_${this.state.yclass.id}`)
                    .getDownloadURL()
                    .then(url => {
                        this.setState({url});

                        this.setState(prevState => ({
                            yclass: {
                                ...prevState.yclass,
                                image_url: url,
                            }
                        }));

                        this.updateYclass();
                    });
            }
        );
    };

    render() {
        this.localize();
        return (
            <>
                <input type="file" id="file" ref={this.fileRef} style={{display: "none"}}
                       onChange={this.onChangeFile.bind(this)}/>

                {this.state.showTeacherModal &&
                    this.renderTeacherModal()
                }

                {this.state.showRoomModal &&
                    this.renderRoomModal()
                }

                {this.state.showSaveClassWarning === true &&
                    this.showSaveClassWarning()
                }

                <Card className="bg-secondary shadow">
                    <CardHeader className="bg-white border-0">

                        {this.state.showCTModal &&
                            this.renderCTModal()
                        }
                        {this.state.yclass && this.state.yclass.name &&
                            <Row className="align-items-center" style={{display: "flex", alignItems: "center"}}>

                                {this.state.yclass && this.state.yclass.id ?
                                    (<Col xs="10" sm="10" lg="10">
                                        <FormGroup style={{verticalAlign: 'center', marginBottom: 0, fontWeight: 700}}>
                                            <Select
                                                style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                }}
                                                placeholder={resourceStrings.class_type}
                                                className="form-control-alternative"
                                                value={this.resolveClassType()}
                                                onChange={this.handleClassTypeChanged}
                                                options={this.classTypeOptions()}
                                            />
                                        </FormGroup>
                                    </Col>) :
                                    (
                                        <Col xs="10">
                                            <h3 className="mb-0">{this.state.yclass ? this.state.yclass.name : ""}</h3>

                                        </Col>
                                    )
                                }

                                <Col xs="2" sm="2" lg="2" md="2">
                                    <div className="modal-header float-right">
                                        <button
                                            aria-label="Close"
                                            className="close"
                                            data-dismiss="modal"
                                            type="button"
                                            onClick={e => this.props.closeEditClassView(e)}
                                        >
                                            <span aria-hidden={true}>×</span>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        }

                        {this.state.isLoading &&
                            <RotateCircleLoading color="default"/>
                        }
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={this.handleSubmit}>
                            {(!this.state.yclass || !this.state.yclass.id) &&
                                <Row>
                                    <Col lg="12">
                                        <FormGroup>
                                            <label
                                                className="form-control-label"
                                            >
                                                {resourceStrings.class_type}
                                            </label>
                                            <Row>
                                                <Col lg="12">
                                                    <Select
                                                        style={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)'
                                                        }}
                                                        placeholder={commonStrings.select}
                                                        className="form-control-alternative"
                                                        value={this.state.classType ? {
                                                            value: this.state.classType.id,
                                                            label: this.state.classType.name
                                                        } : null}
                                                        onChange={this.handleClassTypeSelected}
                                                        options={this.classTypeOptions()}
                                                    />
                                                </Col>
                                            </Row>
                                            {!this.state.yclass && this.props.createClassNewClassType &&
                                                <Button
                                                    style={{marginTop: 4, float: "left"}}
                                                    color="secondary"
                                                    outline="button"
                                                    size="sm"
                                                    onClick={e => this.props.createClassNewClassType(e)}
                                                >
                                                    {resourceStrings.add_class_type}
                                                </Button>
                                            }

                                            {!this.state.yclass && this.props.goToProfile &&
                                                <>
                                                    <div>
                                                        <i><small>{resourceStrings.no_ct_expl}</small></i>
                                                    </div>
                                                    <div>
                                                        <Button
                                                            style={{marginTop: 4, float: "left"}}
                                                            color="secondary"
                                                            outline="button"
                                                            size="sm"
                                                            onClick={e => this.props.goToProfile(e)}
                                                        >
                                                            {commonStrings.navigation.go_to_profile}
                                                        </Button>
                                                    </div>
                                                </>
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                            }
                            {this.state.yclass &&
                                <div className="pl-lg-4">
                                    <Row>
                                        <Col lg={this.state.yclass.is_workshop ? "6" : "12"}>
                                            <FormGroup style={{verticalAlign: 'center='}}>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-start"
                                                >
                                                    <i className="ni ni-calendar-grid-58 mr-1"/>
                                                    {resourceStrings.class_date}
                                                </label>
                                                <Input
                                                    className={this.state.validation.date === true ? "form-control-alternative" : "is-invalid"}
                                                    onChange={this.handleChange}
                                                    defaultValue={this.state.yclass.date}
                                                    id="input-date"
                                                    type="date"
                                                />
                                            </FormGroup>
                                        </Col>

                                        {this.state.yclass.is_workshop &&
                                            <Col lg="6">
                                                <FormGroup style={{verticalAlign: 'center='}}>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-date-end"
                                                    >
                                                        <i className="ni ni-calendar-grid-58 mr-1"/>
                                                        {resourceStrings.end_date}
                                                    </label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        onChange={this.handleChange}
                                                        defaultValue={this.state.yclass.date_end}
                                                        id="input-date-end"
                                                        type="date"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        }
                                    </Row>
                                    <Row>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label
                                                    style={{marginRight: 10}}
                                                    className="form-control-label"
                                                    htmlFor="input-start"
                                                >
                                                    <i className="ni ni-watch-time mr-1"/>
                                                    {resourceStrings.starts_at}
                                                </label>

                                                <TimePicker name={resourceStrings.starts_at} clearIcon={null}
                                                            maxDetail={"minute"} locale={this.state.timeLocale}
                                                            onChange={this.processStatTimeUpdate}
                                                            value={this.state.yclass.start} disableClock={true}/>

                                            </FormGroup>

                                        </Col>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label
                                                    style={{marginRight: 10}}
                                                    className="form-control-label"
                                                    htmlFor="input-end"
                                                >
                                                    {resourceStrings.ends_at}
                                                </label>

                                                <TimePicker name={resourceStrings.starts_at} clearIcon={null}
                                                            maxDetail={"minute"} locale={this.state.timeLocale}
                                                            onChange={this.processEndTimeUpdate}
                                                            value={this.state.yclass.end} disableClock={true}/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                >
                                                    {resourceStrings.teacher}
                                                    <div><label
                                                        style={{fontWeight: 400}}>{resourceStrings.teacher_expl}</label>
                                                    </div>
                                                </label>
                                                <Row>
                                                    <div style={{
                                                        marginLeft: 20,
                                                        display: "flex",
                                                        flexFlow: "row",
                                                        alignItems: "center",
                                                        justifyContent: "leftbu",
                                                        overflowX: "scroll"
                                                    }}>
                                                        {(this.state.yclass?.teachers || []).map((teacher, index) => {
                                                            return <>

                                                    <span style={{
                                                        marginLeft: 6,
                                                        display: "flex",
                                                        flexFlow: "column",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}>
                                                    <img
                                                        alt="teacher photo"
                                                        onClick={e => this.removeTeacher(teacher)}
                                                        style={{
                                                            objectFit: "cover",
                                                            position: "relative",
                                                            imageOrientation: "from-image",
                                                            width: "40px",
                                                            height: "40px",
                                                            display: "inline-block",
                                                            borderRadius: "35px",
                                                            cursor: "pointer",
                                                        }}
                                                        src={teacher.photo || placeholderHelper.randomIcon()}
                                                    />

                                                    <label className="ml-1"
                                                           style={{cursor: "pointer", marginTop: 6, padding: 0}}><a
                                                        style={{color: "darkgray"}}
                                                        href="#">{teacher.name.split(" ")[0]}</a>
                                                    </label>
                                                    </span>

                                                            </>
                                                        })}
                                                    </div>

                                                    <Col lg="12">
                                                        <Select
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                transform: 'translateY(-50%)'
                                                            }}
                                                            className="form-control-alternative"
                                                            // value={this.getTeacher()}
                                                            // defaulValue={this.getTeacher()}
                                                            placeholder={commonStrings.select}
                                                            onChange={this.handleTeacherSelected}
                                                            options={this.teacherOptions()}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Button
                                                    style={{marginTop: 4, float: "right"}}
                                                    color="secondary"
                                                    outline="button"
                                                    size="sm"
                                                    onClick={e => this.addTeacher(e)}
                                                >
                                                    {resourceStrings.add_new_teacher}
                                                </Button>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                >
                                                    {resourceStrings.room}
                                                </label>
                                                <Row>
                                                    <Col lg="12">
                                                        <Select
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                transform: 'translateY(-50%)'
                                                            }}
                                                            placeholder={commonStrings.select}
                                                            className="form-control-alternative"
                                                            value={this.getRoom()}
                                                            onChange={this.handleRoomSelected}
                                                            options={this.roomOptions()}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Button
                                                    style={{marginTop: 4, float: "right"}}
                                                    color="secondary"
                                                    outline="button"
                                                    size="sm"
                                                    onClick={e => this.addRoom(e)}
                                                >
                                                    {resourceStrings.add_room}
                                                </Button>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-capacity"
                                                >
                                                    {resourceStrings.capacity}
                                                    <div><label
                                                        style={{fontWeight: 400}}>{resourceStrings.capacity_expl}</label>
                                                    </div>
                                                </label>
                                                <Input
                                                    style={{maxWidth: 100}}
                                                    className="form-control-alternative"
                                                    id="input-capacity"
                                                    placeholder={"1..499"}
                                                    onChange={this.handleChange}
                                                    defaultValue={this.state.yclass?.capacity || ''}
                                                    rows="1"
                                                    type="number"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    {this.state.yclass.is_workshop &&
                                        <span>
                                        <Row>
                                            <Col lg="12">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-details"
                                                    >
                                                        {commonStrings.description}
                                                    </label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        id="input-details"
                                                        placeholder={resourceStrings.class_program_placeholder}
                                                        onChange={this.handleChange}
                                                        defaultValue={this.state.yclass?.details || ''}
                                                        rows="3"
                                                        type="textarea"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg="12">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-image"
                                                    >
                                                        {commonStrings.image}
                                                    </label>

                                                    {this.state.yclass.image_url &&
                                                        <div
                                                            onClick={e => this.chooseImage()}
                                                            className=""
                                                            style={{
                                                                width: 300,
                                                                borderRadius: 10,
                                                                marginTop: 10,
                                                                backgroundSize: "cover",
                                                                backgroundImage: "url(" + this.state.yclass.image_url + ")",
                                                                backgroundPosition: "center",
                                                                minHeight: 150,
                                                                backgroundRepeat: "no-repeat"
                                                            }}
                                                        />
                                                    }

                                                    <div>
                                                        <Button color={"secondary"}
                                                                size="sm"
                                                                onClick={e => {
                                                                    this.state.yclass.image_url ? this.deletePhoto() : this.chooseImage()
                                                                }}>{this.state.yclass.image_url ? commonStrings.delete : commonStrings.upload_image}</Button>
                                                    </div>

                                                </FormGroup>
                                            </Col>
                                        </Row>

                                    </span>

                                    }

                                    <Row>
                                        <Col lg="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input-note"
                                                >
                                                    {commonStrings.note}
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    id="input-note"
                                                    placeholder={resourceStrings.class_note_placeholder}
                                                    onChange={this.handleChange}
                                                    defaultValue={this.state.yclass && this.state.yclass.note ? this.state.yclass.note : ''}
                                                    rows="3"
                                                    type="textarea"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg="12">
                                            <div
                                                className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                <input
                                                    className="custom-control-input"
                                                    id="input-free-cb"
                                                    onChange={this.handleChange}
                                                    checked={this.state.yclass.is_free && this.state.yclass.is_free === true}
                                                    type="checkbox"
                                                />
                                                <label className="custom-control-label" htmlFor="input-free-cb">
                                                    {resourceStrings.free_class}
                                                </label>
                                                <div>
                                                    <i> <small>{resourceStrings.free_class_expl}</small> </i>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg="12">
                                            <div
                                                className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                <input
                                                    className="custom-control-input"
                                                    id="input-online-cb"
                                                    onChange={this.handleChange}
                                                    checked={this.state.yclass.is_online && this.state.yclass.is_online === true}
                                                    type="checkbox"
                                                />
                                                <label className="custom-control-label" htmlFor="input-online-cb">
                                                    {resourceStrings.online_class}
                                                </label>
                                                <div>
                                                    <i> <small>{resourceStrings.online_class_expl}</small> </i>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    {this.state.yclass.is_online === true &&
                                        <Row>
                                            <Col lg="12">
                                                <FormGroup>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-link"
                                                    >
                                                        {resourceStrings.online_link}
                                                    </label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        id="input-link"
                                                        placeholder={resourceStrings.online_link_placeholder}
                                                        onChange={this.handleChange}
                                                        defaultValue={this.state.yclass && this.state.yclass.link ? this.state.yclass.link : ''}
                                                        rows="3"
                                                        type="textarea"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    }

                                </div>
                            }

                            {this.props.showEditClassType &&

                                <Row style={{marginBottom: 12}}>
                                    <Col lg="12">
                                        <Col className="text-left">

                                            <Button
                                                color={"secondary"}
                                                size="sm"
                                                onClick={e => this.props.showClassTypeEditor(e)}
                                            >
                                                {resourceStrings.edit_class_type}
                                            </Button>
                                        </Col>
                                    </Col>
                                </Row>

                            }
                            <Row>
                                <Col lg="12">
                                    <Col className="text-right">
                                        {this.state.yclass && this.state.yclass.id &&
                                            <Button
                                                color="danger"
                                                outline="button"
                                                size="lg"
                                                onClick={e => this.props.deleteClass(e)}
                                            >
                                                {resourceStrings.delete_class}
                                            </Button>
                                        }
                                        <Button
                                            color="warning"
                                            outline="button"
                                            size="lg"
                                            onClick={e => this.props.closeEditClassView(e)}
                                        >
                                            {commonStrings.close}
                                        </Button>

                                        <Button
                                            color={this.validationCleared() ? "default" : "secondary"}
                                            disabled={!this.validationCleared()}
                                            size="lg"
                                            onClick={e => this.updateYclass(e)}
                                        >
                                            {commonStrings.save}
                                        </Button>
                                    </Col>
                                </Col>
                            </Row>

                        </Form>
                    </CardBody>
                </Card>
            </>
        )
    }

    deletePhoto(e) {
        firebaseHelper.deleteWorkshopPhoto(this.state.yclass)
        this.setState(prevState => ({
            yclass: {
                ...prevState.yclass,
                image_url: null
            }
        }));
    }

    chooseImage(e) {
        if (this.state.yclass.id) {
            this.setState({isLoading: true});
            this.fileRef.current.click();
        }
        else {
            this.toggleShowSaveClassWarning()
        }
    }

    toggleShowSaveClassWarning() {
        this.setState({showSaveClassWarning: !this.state.showSaveClassWarning})
    }

    showSaveClassWarning() {
        return (<Modal
            className="modal-dialog-centered modal-warning"
            contentClassName="bg-warning"
            isOpen={this.state.showSaveClassWarning}
            toggle={() => this.toggleShowSaveClassWarning()}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleShowSaveClassWarning("notificationModal")}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <img
                        alt="..."
                        width={100}
                        height={"auto"}
                        src={require("assets/img/brand/open-white-logo.png")}/>
                    <h4 className="heading mt-4">⚠️</h4>
                    <p className="mt-4">
                        {resourceStrings.create_class_type_to_add_image}
                    </p>
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="text-white ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => this.toggleShowSaveClassWarning("notificationModal")}
                >
                    {commonStrings.close}
                </Button>
            </div>
        </Modal>)
    }

    validateDates() {

        const start = new Date();
        const end = new Date();

        const timeStart = this.state.yclass.start;
        const timeEnd = this.state.yclass.end;

        if (!timeStart || !timeEnd) {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    start: start <= end,
                    end: start <= end,
                }
            }));

            return
        }

        start.setHours(timeStart.split(":")[0], timeStart.split(":")[1], 0);
        end.setHours(timeEnd.split(":")[0], timeEnd.split(":")[1], 0);

        if (dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)) {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    start: start <= end,
                    end: start <= end,
                }
            }));
        } else {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    start: dateHelpers.isValidDate(start),
                    end: dateHelpers.isValidDate(end),
                }
            }));
        }
    }

    handleValidation() {
        this.validateDates();
    }

    validationCleared() {
        return Object.values(this.state.validation).every(item => item)
    }

    getRoom() {
        if (this.state.yclass && this.state.yclass.rooms && this.state.yclass.rooms.length > 0) {
            return {value: this.state.yclass.rooms[0].id, label: this.state.yclass.rooms[0].name}
        } else return ""
    }

    getTeacher() {
        if (this.state.yclass && this.state.yclass.teachers && this.state.yclass.teachers.length > 0) {
            return {value: this.state.yclass.teachers[0].id, label: this.state.yclass.teachers[0].name}
        } else return ""
    }

    roomOptions() {
        if (this.state.rooms && this.state.rooms.length > 0) {
            const options = [];
            this.state.rooms.forEach(t => {
                    options.push({value: t.id, label: t.name})
                }
            );

            return options
        } else return [];
    };

    teacherOptions() {
        if (this.state.teachers && this.state.teachers.length > 0) {
            const options = [];
            this.state.teachers.forEach(t => {
                    options.push({value: t.id, label: t.name})
                }
            );

            return options
        } else return [];
    };

    classTypeOptions() {
        if (this.state.classTypes && this.state.classTypes.length > 0) {
            const options = [];
            this.state.classTypes.forEach(t => {
                    options.push({value: t.id, label: t.name})
                }
            );

            return options
        } else return [];
    };

    removeTeacher = (teacher) => {
        const index = (this.state.yclass.teachers || []).map(i => i.id).indexOf(teacher.id);
        let yclassTeachers = this.state.yclass.teachers || [];
        yclassTeachers.splice(index, 1);

        this.setState(prevState => ({
            yclass: {
                ...prevState.yclass,
                teachers: yclassTeachers
            }
        }));
    }

    handleRoomSelected = selectedOption => {
        const t = this.state.rooms.find(it => it.id === selectedOption.value);
        this.setState(prevState => ({
            yclass: {
                ...prevState.yclass,
                rooms: [t]
            }
        }));
    };

    handleTeacherSelected = selectedOption => {
        const t = this.state.teachers.find(it => it.id === selectedOption.value);
        let yclassTeachers = this.state.yclass.teachers || [];
        const index = yclassTeachers.map(i => i.id).indexOf(t.id);

        if (index < 0) {

            yclassTeachers.push(t)
            this.setState(prevState => ({
                yclass: {
                    ...prevState.yclass,
                    teachers: yclassTeachers
                }
            }));
        }
    };

    handleClassTypeSelected = selectedOption => {
        const ct = this.state.classTypes.find(it => it.id === selectedOption.value);
        this.setState(prevState => ({
            classType: ct,
            yclass: resourceHelper.classTemplateFromClassType(this.state.yclass ? this.state.yclass.date : this.state.date ? this.state.date : new Date(), ct)
        }));
    };

    handleClassTypeChanged = selectedOption => {
        const ct = this.state.classTypes.find(it => it.id === selectedOption.value);
        this.setState(prevState => ({
            classType: ct,
        }));

        this.setState(prevState => ({
            classType: ct,
            yclass: {
                ...prevState.yclass,
                class_type_id: ct.id,
                name: ct.name,
                is_workshop: ct.is_workshop,
            }
        }));
    };

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        // studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        // alertStrings.setLanguage(loc);
    }

    closeEditTeacherView(e) {
        if (e) {
            e.preventDefault();
        }

        this.setState({showTeacherModal: false});
        this.getTeachers()
    }

    closeEditRoomView(e) {
        if (e) {
            e.preventDefault();
        }

        this.setState({showRoomModal: false});
        this.getRooms()
    }

    getTeachers() {
        this.setState({isLoading: true});

        ResourceApiService.teachers()
            .then(res => {
                this.setState({
                    teachers: res,
                    isLoading: false
                });

            })
            .catch((e) => {
                this.props.handleError(e)
            });
    }

    getRooms() {
        this.setState({isLoading: true});

        ResourceApiService.rooms()
            .then(res => {
                this.setState({
                    rooms: res,
                    isLoading: false
                });

            })
            .catch((e) => {
                this.props.handleError(e)
            });
    }

    addTeacher(e) {
        e.preventDefault();

        this.setState({
            showTeacherModal: true,
            showRoomModal: false
        })
    }

    toggleTeacherModal = state => {
        this.setState({
            showTeacherModal: !this.state.showTeacherModal
        });
    };

    toggleRoomModal = state => {
        this.setState({
            showRoomModal: !this.state.showRoomModal
        });
    };

    renderTeacherModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showTeacherModal}
                toggle={() => this.toggleTeacherModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.add_teacher}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <EditTeacherView closeEditTeacherView={this.closeEditTeacherView} modal={true}/>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    renderRoomModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showRoomModal}
                toggle={() => this.toggleRoomModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.add_room}</h4>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <EditRoomView closeEditRoomView={this.closeEditRoomView}/>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    addRoom(e) {
        e.preventDefault();

        this.setState({
            showTeacherModal: false,
            showRoomModal: true
        })
    }

    resolveClassType() {
        if (this.state.classType) {
            return {
                value: this.state.classType.id,
                label: this.state.classType.name
            }
        } else {
            if (this.state.yclass && this.state.yclass.class_type_id && this.state.classTypes) {
                const classType = this.state.classTypes.find((ct) => {
                    return ct.id == this.state.yclass.class_type_id
                })
                if (classType) {
                    return {
                        value: classType.id,
                        label: classType.name
                    }
                }
            }

        }
    }

    processStatTimeUpdate(time) {
        this.setState(prevState => ({
            yclass: {
                ...prevState.yclass,
                start: time
            }
        }));
    }

    processEndTimeUpdate(time) {
        this.setState(prevState => ({
            yclass: {
                ...prevState.yclass,
                end: time
            }
        }));
    }
}

EditClassView.propTypes = propTypes;

export default EditClassView;